import { inject } from '@angular/core';
import { AuthConfig, FeatureToggles } from '@spartacus/core';
import { environment } from '../../../environments/environment';

export const defaultAuthConfig: AuthConfig = {
  authentication: {
    client_id: environment.authclientId,
    tokenEndpoint: '/oauth/token',
    revokeEndpoint: '/oauth/revoke',
    loginUrl: '/oauth/authorize',
    OAuthLibConfig: {
      scope: '',
      customTokenParameters: ['token_type'],
      strictDiscoveryDocumentValidation: false,
      skipIssuerCheck: true,
      disablePKCE: false,
      oidc: false,
      clearHashAfterLogin: false,
      responseType: 'code',
    },
    customLoginPage: {
      csrfEndpoint: '/csrf',
      loginFormEndpoint: '/login',
    },
  },
};

export function defaultAuthConfigFactory(): AuthConfig {
  const { authorizationCodeFlowByDefault } = inject(FeatureToggles);

  if (authorizationCodeFlowByDefault) {
    return defaultAuthConfig;
  } else {
    const config = {
      authentication: {
        ...defaultAuthConfig.authentication,
        client_id: 'mobile_android',
        client_secret: 'secret',
        sendAuthHeaderOnRevoke: true,
        useClientTokens: true,
        OAuthLibConfig: {
          ...defaultAuthConfig.authentication?.OAuthLibConfig,
          disablePKCE: true,
        },
      },
    } satisfies AuthConfig;

    delete config.authentication.OAuthLibConfig.responseType;
    delete config.authentication.customLoginPage;
    return config;
  }
}